import React from 'react'

import CountChip from '../../../components/inspector/shared/CountChip'
import ProductTypeChip from '../../../components/ProductTypeChip'
import { renderProductNameWithMeta } from '../../exceptions/shared/productRenderers'
import type { ExceptionConfig } from '../../exceptions/types'
import { fmtInt, fmtMoney, fmtQty, fmtQtyShort } from './formatters'
import type { CompositeDepthRow } from './types'

export const compositeConfig: ExceptionConfig = {
  codes: [],
  complexity: 'comparison',
  rowKeyField: 'ls_id',
  defaultSortColumn: 'composite_units_sold',
  defaultSortDirection: 'desc',
  clientDefaultPageSize: 100,
  columns: [
    {
      key: 'name',
      label: 'Product',
      align: 'left',
      render: (value, row, ctx) => {
        const r = row as CompositeDepthRow
        const enriched = {
          ...r,
          product_type:
            r.use_case === 'dosage' ? 'composite_dosage' : 'composite_kit',
        }
        return renderProductNameWithMeta(value, enriched, ctx, {
          showInactiveChip: false,
        })
      },
    },
    {
      key: 'use_case',
      label: 'Type',
      align: 'center',
      render: (_v, row) => {
        const r = row as CompositeDepthRow
        return (
          <ProductTypeChip
            productType={
              r.use_case === 'dosage' ? 'composite_dosage' : 'composite_kit'
            }
            dense
          />
        )
      },
    },
    {
      key: 'included_product_count',
      label: 'Included products',
      align: 'center',
      render: (_v, row) => {
        const r = row as CompositeDepthRow
        const items = r.included_products.map((ip) => ({
          id: ip.ls_id,
          primary: ip.name,
          secondary: ip.sku,
          metrics: [fmtQty(ip.quantity)],
          link: ip.lightspeed_product_link,
        }))
        const chipLabel =
          r.use_case === 'dosage' && r.qty_per_composite !== null
            ? fmtQtyShort(r.qty_per_composite)
            : r.included_product_count.toLocaleString()
        return (
          <CountChip
            count={r.included_product_count}
            items={items}
            label="Included products"
            metricHeaders={['Qty']}
            overrideLabel={chipLabel}
          />
        )
      },
    },
    {
      key: 'composite_units_sold',
      label: 'Composite units sold',
      align: 'right',
      render: (v) => fmtInt(v as number),
    },
    {
      key: 'composite_revenue',
      label: 'Composite revenue',
      align: 'right',
      render: (v) => fmtMoney(v as number),
    },
    {
      key: 'included_units_sold_direct',
      label: 'Included product sales (direct)',
      align: 'right',
      render: (v) => fmtInt(v as number),
    },
    {
      key: 'included_revenue_direct',
      label: 'Included product revenue (direct)',
      align: 'right',
      render: (v) => fmtMoney(v as number),
    },
  ],
}
